/** `anonymous#NNNNNN` — privacy-safe fallback nickname (no email leak). */
export function anonymousNickname(): string {
  return `anonymous#${String(Math.floor(Math.random() * 1_000_000)).padStart(6, '0')}`;
}
